//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      window: null,
      icon: 'mdi-fullscreen',
      popup: false
    };
  },

  methods: {
    toggleFullScreen() {
      this.popup = false;
      if (!this.window.document.fullscreenElement) {
        this.window.document.documentElement.requestFullscreen();
        this.icon = 'mdi-fullscreen-exit';
      } else {
        if (this.window.document.exitFullscreen) {
          this.window.document.exitFullscreen();
          this.icon = 'mdi-fullscreen';
        }
      }
    },

    mouseEnter() {
      this.popup = true;

      setTimeout(() => {
        this.popup = false;
      }, 2000)
    },
  },

  mounted() {
    this.window = window;
  }
};
